export default __webpack_public_path__ + "static/media/logo-admin.bb956cd3.svg";